import { Injectable, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private breakpointObserver = inject(BreakpointObserver);

  readonly isTabletOrDesktop: Signal<boolean> = toSignal(
    this.breakpointObserver.observe(BREAKPOINT_TABLET).pipe(
      map(result => result.matches)
    ),
    { initialValue: false }
  );

  readonly isDesktop: Signal<boolean> = toSignal(
    this.breakpointObserver.observe(BREAKPOINT_DESKTOP).pipe(
      map(result => result.matches)
    ),
    { initialValue: false }
  );
}
